import { storage } from '@webclient/lib/agent';

import { useMutation } from '@tanstack/react-query';

type ParamsType = {
  key: string;
};

export default function useDeleteCredentialByKey() {
  return useMutation({
    mutationKey: ['credentials'],
    mutationFn: async ({ key }: ParamsType) =>
      await storage.deleteFile({ key }),
    onError: (error) => {
      console.error(error);
    },
  });
}
